import { z } from '../zod.js';
import {
  CursorPaginationValidationBaseSchema,
  withCursorPaginationValidation,
} from '../shared/cursorPagination';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { LivemodeFilterValidationSchema } from '../shared/livemode';
import { SUBSCRIPTION_STATUSES, SubscriptionStatusValidationEnum } from './enum';

export const SubscriptionListQueryValidationSchema = withCursorPaginationValidation(
  CursorPaginationValidationBaseSchema.extend({
    search: z.string().optional().meta({
      description:
        'Search by customerEmail, customerName, productTitle, or orderId. Contains match.',
    }),
    pageId: ObjectIdStringValidationSchema.optional().meta({
      description: 'Filter subscriptions by page ID.',
    }),
    customerId: ObjectIdStringValidationSchema.optional().meta({
      description: 'Filter subscriptions by customer ID.',
    }),
    orderId: z.string().optional().meta({ description: 'Filter by exact order ID.' }),
    createdAfter: z.iso.datetime().optional().meta({
      description: 'Filter by lower bound of createdAt.',
    }),
    createdBefore: z.iso.datetime().optional().meta({
      description: 'Filter by upper bound of createdAt.',
    }),
    abandonmentStatus: z.enum(['abandoned', 'recovered']).optional().meta({
      description: 'Filter by `abandoned` or `recovered` subscriptions.',
    }),
    status: SubscriptionStatusValidationEnum.optional().meta({
      description: `Filter by subscription lifecycle status. Valid values: ${Object.values(SUBSCRIPTION_STATUSES).join(', ')}.`,
    }),
    livemode: LivemodeFilterValidationSchema,
  }).refine(
    data =>
      !(
        data.createdAfter &&
        data.createdBefore &&
        Date.parse(data.createdAfter) > Date.parse(data.createdBefore)
      ),
    {
      message: 'createdAfter must be earlier than or equal to createdBefore',
      path: ['createdBefore'],
    },
  ),
);
